import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import dayjs from "dayjs";
import React from "react";

const useStyles = makeStyles({
	root: {
		minWidth: "100%"
	},
	table: {
		minWidth: "500px"
	}
});


export default function Info({ asset }) {
	const classes = useStyles();

	return (
		<TableContainer className={classes.root}>
			<Table className={classes.table} size="small" aria-label="a dense table">
				<TableBody>
					<TableRow key={"address"}>
						<TableCell colSpan={2} align="left">
							<b>{`Address: `}</b>
							{asset.beacon.positions[0].address}
						</TableCell>
						<TableCell colSpan={2} align="left">
							<b>{`Battery: `}</b>
							{asset.beacon.positions[0].beacons[0].battery ? `${asset.beacon.positions[0].beacons[0].battery} V` : 'Not Available'}
						</TableCell>
					</TableRow>
					<TableRow key={"last-signal"}>
						<TableCell colSpan={2} align="left">
							<b>{`Last Signal: `}</b>
							{dayjs(asset.beacon.positions[0].position_timestamp).format('DD-MM-YYYY HH:mm:ss')}
							{asset?.beacon?.positions[0]?.position_timestamp ? ` (${dayjs(asset?.beacon?.positions[0]?.position_timestamp).fromNow()})` : ''}
						</TableCell>
						<TableCell colSpan={2} align="left">
							<b>{`Temperature: `}</b>
							{asset.beacon.positions[0].beacons[0].temperature ? `${asset.beacon.positions[0].beacons[0].temperature} °C` : 'Not Available'}
						</TableCell>
					</TableRow>
					<TableRow key={"last-signal"}>
						<TableCell colSpan={4} align="center">
							<b>{`RSSI Signal: `}</b>
							{asset.beacon.positions[0].beacons[0].signal ? `${asset.beacon.positions[0].beacons[0].signal} dBM` : 'Not Available'}
						</TableCell>
					</TableRow>
				</TableBody>
			</Table>
		</TableContainer>
	);
}
